module.exports = __webpack_public_path__ + "img/thumbnail_GiantPanda_j_albino.ee33a88e.png";